<template>
  <a-modal
    title=""
    :width="500"
    centered
    :visible="visible"
    :mask-closable="false"
    :closable="false"
  >
    <ul class="list">
      <li class="list-item" v-for="(item, i) in msgArr" :key="i">
        {{ i+=1 }}.&nbsp;&nbsp;<p>{{ item.message }}</p>
      </li>
    </ul>
    <template slot="footer">
      <a-button :loading="loading" key="submit" type="primary" @click="submit">
        知道了
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'GroupMsgModal',

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      msgArr: 'common/groupMsgArr'
    })
  },

  data() {
    return {
      tableLoading: false,
      studentList: [],
      loading: false
    }
  },

  methods: {
    submit() {
      this.loading = true
      const ids = this.msgArr.map(k => k.id)
      this.$service.common.clashRead({ ids }).then(() => {
        this.loading = false
        this.$emit('update:visible', false)
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading = false
        this.$emit('update:visible', false)
      })
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.ant-modal-body) {
  padding-bottom: 20px;
}
.list {
  max-height: 300px;
  overflow-y: scroll;
  margin-bottom: 0;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb{
    width: 6px;
    height: 6px;
    opacity: 0.8;
    border-radius: 3px;
    background: #C7C7C7;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-button {
    background: transparent;
  }
  &::-webkit-scrollbar-corner {
    background: transparent;
  }
  .list-item {
    display: flex;
    &:not(:first-child) {
      margin-top: 12px;
    }
  }
  p {
    white-space:normal;
    word-break:break-all;
  }
}
</style>